import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule }from '../../ng-zorro-antd/ng-zorro-antd.module';

import { TokenComponent } from './token.component';
import { TokenLancamentoComponent } from './token-lancamento/token-lancamento.component';



@NgModule({
  declarations: [TokenComponent, TokenLancamentoComponent],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    RouterModule,
    BrowserModule,
    NgZorroAntdModule,
  ]
})
export class TokenModule { }
